import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa'; 
import whyChooseImage from '../../assets/images/why-choose-image.jpg';
import './WhyChoose.scss';

const WhyChoose = () => {
  return (
    <section className="why-choose">
      <div className="container">
        <div className="content">
          <div className="text-content">
            <h1 className="section-title">Why Choose Simak?</h1>
            <p className="section-subtitle">
              We combine expertise, innovation, and personalized service to deliver exceptional results for your business.
            </p>
            <ul className="features">
              <li>
                <strong>Expert Team</strong>
                <p>Certified professionals with years of industry experience</p>
              </li>
              <li>
                <strong>Proven Results</strong>
                <p>Track record of successful projects and satisfied clients</p>
              </li>
              <li>
                <strong>Fast Delivery</strong>
                <p>Efficient processes that get you results quickly</p>
              </li>
            </ul>
            <Link to="/about" className="learn-more-btn">
              Discover More <FaArrowRight className="arrow-icon" />
            </Link>
          </div>
          <div className="image-content">
            <img src={whyChooseImage} alt="Why choose Simak" className="feature-image" />
            <div className="stat-overlay">
              <h2>98%</h2>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;